var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40b390f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable-mutable-fields" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "columns small-12" };
const _hoisted_4 = { class: "values-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Values", -1 /* HOISTED */));
const _hoisted_6 = { class: "values-list" };
const _hoisted_7 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_8 = { class: "value-item-header" };
const _hoisted_9 = { class: "variant-key" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */));
const _hoisted_11 = { class: "form" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "columns small-12" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Variant", -1 /* HOISTED */));
import { computed, ref } from "vue";
import ComponentVariableValue from "../item/value/ComponentVariableValue.vue";
import Button from "src/shared/v-components/ui/Button.vue";
import { ElDialog } from "element-plus";
import { confirm } from "src/shared/v-components/ui/message-box";
import { getCampaignComponentVariableDefaultValue } from "src/shared/store/campaign-component/variable/model/campaign-component-variable-value-defaults";
import { isComponentSocketMutable } from "src/shared/store/component-mutable/model/ComponentSocketMutable";
import ComponentVariableTranslatableToggle from "../drawer-common/ComponentVariableTranslatableToggle.vue";
import { useComponentVariableTranslatableMutable } from "../drawer-common/useComponentVariableTranslatableMutable";
import { useDefaultVariant } from "src/shared/store/component-built/composables/useDefaultVariant";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableMutableFields',
    props: {
        componentMutable: {}
    },
    setup(__props) {
        const props = __props;
        const isAddVariantDialogVisible = ref(false);
        const newVariantKey = ref("");
        const componentMutableKey = computed(() => props.componentMutable.getComponentMutableKey());
        const variableName = computed(() => props.componentMutable.getName());
        const { builtComponent } = useBuiltComponent(() => props.componentMutable.getComponentId());
        const isTranslatable = computed(() => props.componentMutable.isTranslatable());
        const isMultiVariant = computed(() => props.componentMutable.isMultiVariant());
        const supportsMultiVariantMode = computed(() => props.componentMutable.supportsMultiVariantMode());
        const isSocket = computed(() => isComponentSocketMutable(props.componentMutable));
        const variants = computed(() => {
            const values = props.componentMutable.getValues();
            return Object.keys(values);
        });
        const { translatable } = useComponentVariableTranslatableMutable(computed(() => props.componentMutable));
        const { defaultVariant } = useDefaultVariant(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id; });
        const openAddVariantDialog = () => {
            if (variants.value.length === 0) {
                const firstVariant = translatable.value
                    ? defaultVariant.value || "en"
                    : "default";
                addNewVariantWithKey(firstVariant);
            }
            else {
                newVariantKey.value = "";
                isAddVariantDialogVisible.value = true;
            }
        };
        const addNewVariantWithKey = (key) => {
            props.componentMutable.addVariant(key);
            const defaultValue = getCampaignComponentVariableDefaultValue(props.componentMutable.getType());
            props.componentMutable.setValue(key, defaultValue);
            isAddVariantDialogVisible.value = false;
        };
        const addNewVariant = () => {
            if (newVariantKey.value) {
                addNewVariantWithKey(newVariantKey.value);
            }
        };
        const deleteVariant = (variant) => {
            confirm({
                title: `Remove Value`,
                message: `Are you sure you want to remove the value "${variant}"?`,
                confirmButtonText: "Remove",
                onConfirm: (onSuccess) => __awaiter(this, void 0, void 0, function* () {
                    props.componentMutable.removeVariant(variant);
                    onSuccess();
                }),
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ComponentVariableTranslatableToggle, {
                    class: "translatable",
                    translatable: _unref(translatable),
                    "onUpdate:translatable": _cache[0] || (_cache[0] = ($event) => (_isRef(translatable) ? (translatable).value = $event : null)),
                    variableType: props.componentMutable.getType()
                }, null, 8 /* PROPS */, ["translatable", "variableType"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createVNode(Button, {
                                level: 'secondary',
                                onClick: openAddVariantDialog
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" + New Value ")
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (variants.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No values added yet. Click \"+ New Value\" to get started. "))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(variants.value, (variant) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: variant,
                                        class: "value-item"
                                    }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, _toDisplayString(variant), 1 /* TEXT */),
                                            _createVNode(Button, {
                                                level: 'tertiary',
                                                onClick: ($event) => (deleteVariant(variant))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_10
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                        ]),
                                        _createVNode(ComponentVariableValue, {
                                            "component-mutable-key": componentMutableKey.value,
                                            "variable-name": variableName.value,
                                            variant: variant,
                                            "variant-display-mode": 'SINGLE_VARIANT'
                                        }, null, 8 /* PROPS */, ["component-mutable-key", "variable-name", "variant"])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createVNode(_unref(ElDialog), {
                    modelValue: isAddVariantDialogVisible.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((isAddVariantDialogVisible).value = $event)),
                    title: "Enter Variant",
                    width: "400px"
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createVNode(Button, {
                                level: 'secondary',
                                onClick: _cache[2] || (_cache[2] = ($event) => (isAddVariantDialogVisible.value = false))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Cancel ")
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(Button, {
                                "is-disabled": !newVariantKey.value,
                                onClick: addNewVariant
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Add ")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-disabled"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((newVariantKey).value = $event)),
                                        type: "text",
                                        placeholder: "Enter variant",
                                        onKeyup: _withKeys(addNewVariant, ["enter"])
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, newVariantKey.value]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]));
        };
    }
});
